
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/questionnaire",
      function () {
        return require("private-next-pages/questionnaire.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/questionnaire"])
      });
    }
  